import * as z from "zod/v4";

export const searchDynamicVariable = {
  name: "searchDynamicVariable" as const,
  input: z.object({
    variableId: z.string(),
    query: z.string().optional(),
  }),
  output: z.object({
    options: z.array(z.object({ id: z.string(), label: z.string() })),
  }),
};
